// ResourceItem.js
import React from 'react';
import { useDrag } from 'react-dnd';

const ResourceItem = ({ resource, isDisabled }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: resource.type,
      item: { id: resource.id, type: resource.type, label: resource.label },
      canDrag: !isDisabled,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [isDisabled]
  );

  return (
    <div
      ref={isDisabled ? null : drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        backgroundColor: isDisabled ? '#e0e0e0' : 'var(--second-color)',
      }}
      className='dragElement'
    >
      {resource.label}
    </div>
  );
};

export default ResourceItem;
